module.exports = __webpack_public_path__ + "static/temperature_final-8257a98d117052364e78202d0cc15bae.jpg";